import { useMemo } from 'preact/hooks';

/** Classic hex dump: offset, 16 bytes, ASCII. Certificates are a few kB, so no virtualization. */
export function HexView({ data, maxBytes = 65536 }: { data: Uint8Array; maxBytes?: number }) {
  const rows = useMemo(() => {
    const out: string[] = [];
    const n = Math.min(data.length, maxBytes);
    for (let o = 0; o < n; o += 16) {
      const chunk = data.subarray(o, Math.min(o + 16, n));
      const hexs: string[] = [];
      let ascii = '';
      for (let i = 0; i < 16; i++) {
        const b = chunk[i];
        hexs.push(b === undefined ? '  ' : b.toString(16).padStart(2, '0'));
        if (i === 7) hexs.push('');
        ascii += b === undefined ? ' ' : b >= 0x20 && b < 0x7f ? String.fromCharCode(b) : '·';
      }
      out.push(`${o.toString(16).padStart(8, '0')}  ${hexs.join(' ')}  |${ascii}|`);
    }
    if (data.length > maxBytes) out.push(`… ${data.length - maxBytes} more bytes`);
    return out;
  }, [data, maxBytes]);
  return <pre class="hexview">{rows.join('\n')}</pre>;
}
